import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=6fdaa06a&scoped=true"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"
import style0 from "./ProjectManagement.vue?vue&type=style&index=0&id=6fdaa06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdaa06a",
  null
  
)

export default component.exports